var transportationOptionsService = function () {
    this.handleTO = function (to, isGMDealer, isCadillacMake) {
        if (window.appSettings.enablePremiumConciergeFeature) {
            if (to.code === 'need-pickup' && isGMDealer) {
                if (!window.appSettings.enableCadillacPremiumConcierge || (window.appSettings.enableCadillacPremiumConcierge && !isCadillacMake)) { // PREMIUM CONCIERGE
                    to.description = appSettings.resources.Transportation_Options__Premium_Concierge;
                }
                if (window.appSettings.enableCadillacPremiumConcierge && isCadillacMake) { // CADILLAC PREMIUM CONCIERGE
                    to.description = appSettings.resources.Transportation_Options__Cadillac_Premium_Concierge;
                }
            }
        }
        return to;
    };

    // >= 2022 Jeep (Grand) Wagoneer PU/D Functionality
    // deletes PU/D option from the given TransportationOptions array (options)
    // if the current vehicle is not eligible and returns the modified array.
    this.handleWagoneerTO = function (options, isPUDWagoneerModel) {
        if (window.appSettings.IsPickupAndDeliveryWagoneerOnlyEnabled && !isPUDWagoneerModel) {
            options = options.filter(function (el) {
                return !(el.code === 'need-pickup');
            })
        }
        return options;
    };
};

module.exports = transportationOptionsService;
